import { ArrowBackIos } from "@mui/icons-material";
import { Step, StepLabel, Stepper } from "@mui/material";
import React from "react";
import { Button, Navbar } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import SideNav from "../SideNav/SideNav";
import "./status.css";

const steps = ["Seen", "Processing", "Complete"];

const Status = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { complaint } = location.state;

  return (
    <div className="app">
      <div className="app-left">
        <SideNav />
      </div>
      <div className="app-right">
        <Navbar />
        <div className="status">
          <Button
            onClick={() => navigate("/dashboard")}
            variant="success"
            size="sm"
          >
            <ArrowBackIos />
            Back
          </Button>
          <h2>Status Message</h2>
          <div className="status-message">
            <div className="status-header">
              <p> {complaint.username}'s Complaint</p>
              <p className="date">{complaint.time}</p>
            </div>
            <div className="status-text">
              <p>{complaint.complaintMessage}</p>
            </div>
          </div>
          <div className="status-steps">
            <h3>Complaint Status bar</h3>
            <Stepper activeStep={1} alternativeLabel>
              {steps.map((label) => (
                <Step key={label}>
                  <StepLabel>{label}</StepLabel>
                </Step>
              ))}
            </Stepper>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Status;
